export default function install (Vue) {
  const BusinessApi = this

  if (install.installed) return
  install.installed = true

  Object.defineProperty(Vue.prototype, '$businessApi', {
    get () { return BusinessApi.instance }
  })

  Vue.mixin({
    beforeCreate () {
      if (this.$options.businessApi) {
        this.businessApi = this.$options.businessApi
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/business-api/install.js